import { render, staticRenderFns } from "./Blocks1.vue?vue&type=template&id=2d62c40f"
import script from "./Blocks1.vue?vue&type=script&lang=js"
export * from "./Blocks1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports